import PropTypes from 'prop-types';
import { track } from '../../common/eventTracking/tracker';
import H1 from 'UIComponents/elements/headings/H1';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { upgradeDataPropsInterface } from '../../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import H6 from 'UIComponents/elements/headings/H6';
import { MODAL_TYPES } from '../constants';
import { loadAndOpenSalesChat } from '../../utils/loadAndOpenSalesChat';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  GET_A_CALL,
  MEETING,
  EMAIL
} = MODAL_TYPES;
export const AssignableModalBody = ({
  _overrideModalHeaderText,
  handleIframeSizeChange,
  setCurrentModalView,
  showChatButton,
  upgradeData,
  onClose,
  isUpgradePoint,
  repInfo
}) => {
  const handleClick = (communicationKey, trackingAction) => {
    track('communicationMethodsInteraction', Object.assign({
      action: trackingAction
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint), {
      repName: getRepName(repInfo)
    }));
    handleIframeSizeChange(communicationKey);
    setCurrentModalView(communicationKey);
  };
  const handleClickChat = () => {
    loadAndOpenSalesChat({
      upgradeData,
      isRetail: false,
      isAssignable: true
    });
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked chat with us'
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint), {
      repName: getRepName(repInfo)
    }));
    onClose();
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "assignable-modal-body",
    children: [/*#__PURE__*/_jsx(H1, {
      className: "m-bottom-8",
      children: _overrideModalHeaderText || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.communicationMethods.title"
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        justify: "center",
        children: [/*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "communication-method-call",
          size: "large",
          onClick: () => handleClick(GET_A_CALL, 'clicked contact sales with phone call'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.call"
          }),
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "calling-small",
            height: 75
          })
        }), /*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "communication-method-meeting",
          size: "large",
          onClick: () => handleClick(MEETING, 'clicked contact sales with meeting'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.meeting"
          }),
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "meetings-small",
            height: 75
          })
        }), /*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "communication-method-email",
          size: "large",
          onClick: () => handleClick(EMAIL, 'clicked send email'),
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.email"
          }),
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "successfully-connected-email",
            height: 75
          })
        }), showChatButton && /*#__PURE__*/_jsx(UISelectableButton, {
          "data-test-id": "communication-method-chat",
          size: "large",
          selected: false,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.chatWithUs"
          }),
          onClick: handleClickChat,
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "contacts-chat",
            height: 75
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left m-top-9",
        children: [/*#__PURE__*/_jsx(H6, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.footer.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.communicationMethods.footer.body"
          })
        })]
      })]
    })]
  });
};
AssignableModalBody.propTypes = Object.assign({
  _overrideModalHeaderText: PropTypes.string,
  handleIframeSizeChange: PropTypes.func.isRequired,
  setCurrentModalView: PropTypes.func.isRequired,
  showChatButton: PropTypes.bool.isRequired,
  repInfo: PropTypes.object
}, upgradeDataPropsInterface);